import Icons from "assets";

export const EmailWriterPreviewLoadingState = () => (
  <div className="flex w-full justify-center pt-2">
    <div
      className="mx-auto flex w-full max-w-[400px] flex-col gap-[26px] px-4 py-3"
      data-testid="email-writer-preview-loading"
      role="status"
      aria-live="polite"
    >
      <div className="flex w-full flex-col gap-2">
        <div className="flex h-[26px] items-center gap-2">
          <Icons.Spinner className="size-4 shrink-0 animate-spin text-aqua-600" />
          <p className="text-base text-gray-900">Writing email draft...</p>
        </div>
        <p className="text-sm text-gray-900">
          This may take a few moments, and notification will be sent upon completion.
        </p>
      </div>
      <div className="flex w-full flex-col gap-5">
        <div className="h-5 w-full max-w-[calc(100%-118px)] rounded bg-gray-200" />
        <div className="flex flex-col gap-3">
          <div className="h-3 w-full max-w-[329px] rounded bg-gray-200" />
          <div className="h-3 w-full max-w-[301px] rounded bg-gray-200" />
          <div className="h-3 w-full max-w-[213px] rounded bg-gray-200" />
        </div>
        <div className="flex flex-col gap-3 pt-2">
          <div className="h-3 w-full max-w-[347px] rounded bg-gray-200" />
          <div className="h-3 w-full max-w-[301px] rounded bg-gray-200" />
          <div className="h-3 w-full max-w-[249px] rounded bg-gray-200" />
        </div>
        <div className="h-11 w-full max-w-[164px] rounded-lg bg-gray-200" />
      </div>
    </div>
  </div>
);
